export default "__VITE_ASSET__sHabCUGL__"